import { gql } from "@apollo/client";

export const GET_CCTV_STATUS = gql`
    query MyQuery {
        its_cctv_statuses(order_by: [{cctv_id: asc}, {created_at: desc}], distinct_on: cctv_id) {
            message
            id
            cctv_id
            created_at
            is_online
        }
    }
`;